import React from 'react';
import styled from 'styled-components';
import { LAYOUT_BREAK_SMALL } from '../../containers/App/constants';
import { COLOR_PRIMARY_1, COLOR_BG_LIGHT } from '../../vars';
import { HBox } from '../Box';
import { Button } from '../Buttons';
import { Times, Left } from '../Icon';

const Container = styled.div`
  position: fixed;
  display: flex;
  z-index: 9999;
  background-color: ${props => (props.mobileView ? 'none' : 'rgba(0, 0, 0, 0.9)')};
  top: ${props => (props.mobileView ? '2%' : '0')};
  left: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  align-items: center;
  overflow: auto;

  .header {
    background-color: ${COLOR_PRIMARY_1};
    color: white;
    width: auto;
    margin: -12px 0 0 0;
    padding: 6px 24px;
    .button {
      margin: 0;
      text-align: right;
      width: 40px;
    }
  }

  .button {
    width: ${props => (props.buttonWidth ? props.buttonWidth : '200px')};
  }

  @media (max-width: 768px) {
    height: ${props => (props.mobileView ? 'auto' : '100vh')};
    overflow: scroll;
    width: 100%;
    .header {
      background-color: ${COLOR_PRIMARY_1};
      color: white;
      width: 100%;
      margin: 0;
      padding: 6px 24px;
      .button {
        margin: 0;
        text-align: right;
        width: 40px;
      }
    }
  }
`;

const Inner = styled.div`
  background-color: ${props => (props.pdfView ? 'lightgrey' : 'rgba(255, 255, 255, 1)')};
  
  padding: 12px 0 0 0;
  min-width: 1000px;
  width: ${props => (props?.wider ? '90%' : props.halfParentWide ? '70%' : props?.mediumWide ? '60%' : 'auto')};
  min-height: ${props => (props?.height ? props?.height : 'auto')};
  max-height: 90%;
  overflow: auto;

  @media (max-width: ${LAYOUT_BREAK_SMALL}px) {
    min-width: 300px;
    width: 100%;
    max-height: 80%;
    padding-top: 0;
  }
`;

const TopControls = styled.div`
  text-align: right;
  .button {
    width: 60px;
    padding: 12px;
  }
`;

const Title = styled.div`
  font-weight: 600;
`;

export function Modal(props) {
  return (
    <Container
      mobileView={props.mobileView}
      onMouseDown={e => {
        if (e.currentTarget == e.target) {
          props.onClose();
        }
      }}
      buttonWidth={props.buttonWidth}
      // onClick={e => props.onClose()}
      className="modal-container"
    >
      <Inner
        onClick={evt => evt.stopPropagation()}
        className="modal-inner"
        mediumWide={props.mediumWide}
        wider={props.wider}
        halfParentWide={props.halfParentWide}
        pdfView={props.pdfView}
        height={props.height}
      >
        {!props.mobileView && (
          <HBox className="header" vCenter>
            <Title>{props.title}&nbsp;</Title>
            <TopControls>
              <Button onClick={props.onClose}>
                <Times />
              </Button>
            </TopControls>
          </HBox>
        )}

        <div style={{ padding: 12 }}>{props.children}</div>
      </Inner>
    </Container>
  );
}

export const ModalControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px -12px -12px -12px;
  background-color: #ddd;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
`;
